const { useCallback, useRef, useState } = require('react');

const internals = {
    noop: () => {}
};

exports.useClassDetailDialog = function useClassDetailDialog() {

    const [dialog, setDialog] = useState({
        confirmLabel: '',
        content: '',
        declineLabel: '',
        isOpen: false,
        title: ''
    });
    const confirmRef = useRef(internals.noop);
    const cancelRef = useRef(internals.noop);

    const closeDialog = useCallback(() => {

        setDialog((current) => ({ ...current, isOpen: false }));
    }, []);

    const openDialog = useCallback(({ title, message, confirm, cancel, declineLabel, confirmLabel }) => {

        confirmRef.current = confirm || internals.noop;
        cancelRef.current = cancel || internals.noop;
        setDialog({
            confirmLabel: confirmLabel || '',
            content: message,
            declineLabel: declineLabel || '',
            isOpen: true,
            title
        });
    }, []);

    const cancelDialog = useCallback(() => {

        closeDialog();
        cancelRef.current();
    }, [closeDialog]);

    const confirmDialog = useCallback(() => {

        closeDialog();
        confirmRef.current();
    }, [closeDialog]);

    return {
        cancelDialog,
        closeDialog,
        confirmDialog,
        dialog,
        openDialog
    };
};
